<template>
  <div class="pagination-bg pagination-bg-sm pagination-bg-lg pagination-bg-2xl bg-center">
    <div class="max-w-7xl mx-auto pt-16 sm:pt-20">
    <div class="flex justify-center"><img src="@/assets/policies.svg" alt="使用條款及隱私權政策" class="sm:w-16 sm:h-16"/></div>
    <h1 class="text-3xl sm:text-4xl font-black mt-5">使用條款及隱私權政策</h1>
    </div>
  </div>
  <div class="max-w-7xl mx-auto mt-10 my-20 px-5 sm:px-10">
    <div class="flex space-x-5 justify-start">
        <router-link to="/">
          <div class="font-bold text-lg">首頁</div>
        </router-link>
      <p class="text-lg">></p>
      <p class="text-lg text-color-blue font-bold text-left">使用條款及隱私權政策</p>
    </div>
    <div class="sm:flex sm:space-x-10 mt-10 sm:items-end mb-10">
    <h2 class="text-3xl font-black text-color-brown">使用條款</h2>
    <h3 class="text-xl mt-3 sm:mt-0">v.20230801</h3>
    </div>
      <h3 class="text-2xl font-black my-5 text-left">適用範圍</h3>
      <p class="text-lg text-left">本網站由農業部生物多樣性研究所負責維運。本站其上素材與資料，除另行標示者外，歸該單位所有。
      <br>本頁面的著作權政策，適用於您TAIE網站活動時，所涉及之授權與被授權關係。
      <br>使用者繼續使用TAIE網站服務之作為，視為當事人明示同意下述之使用條款。</p>
      <h3 class="text-2xl font-black my-5 text-left">資料的授權與分享方式</h3>
      <p class="text-lg text-left">TAIE網站刊載之所有資料，除純粹事實性紀錄資訊不受著作權利保護者，及另有聲明者，其餘皆採「政府資料開放授權條款」授權公眾使用。
      <br>依「政府資料開放授權條款」，使用者得不限時間、地域及目的，對所提供之資料進行重製、改作、編輯、公開傳輸，或為其他依法需取得著作授權方可行之之利用。
      此一授權行為不會嗣後撤回，使用者亦無須取得書面或其他方式授權。然使用時，須採下列格式標示資料來源為農業部生物多樣性研究所植物標本館(https://taie.tbn.org.tw)。</p>
      <p class="text-lg text-left source my-2">部份資料出處：農業部生物多樣性研究所植物標本館(https://taie.tbn.org.tw)</p>
      <p class="text-lg text-left">上述資料原依「政府資料開放授權條款 (Open Government Data License: https://data.gov.tw/license)」進行公眾釋出，使用者於遵守該條款各項規定之前提下，得利用之。本網站於部分頁面提供資料下載功能，惟本網站不對前述下載資料負保存之責任。為避免前述下載資料滅失，使用者應自行保留資料複本。</p>
      <h3 class="text-2xl font-black my-5 text-left">相關事項說明</h3>
      <p class="text-lg text-left">TAIE網站授權範圍僅及於著作權及其相關權利保護之範圍，不及於其他智慧財產權利，包括但不限於專利、商標、及機關標誌或商號圖示之提供。
      <br>使用TAIE網站提供之各項資料與素材，不論其受著作權利保護與否，使用者不得惡意變更其相關資訊，若編輯、改作後所展示之資訊與原不符而造成損害，使用者須自負民事、刑事上之法律責任。
      <br>使用者利用本網站無償提供之各項資料與素材，受有損害或損失，或致第三人受有損害或損失，除法令另有規定外，本網站及其維運單位不負任何賠償或補償之責。</p>
  </div>
  <div class="bg-color">
    <div class="max-w-7xl mx-auto pt-10 px-5 sm:px-10 pb-20">
      <div class="sm:flex sm:space-x-10 mt-10 sm:items-end mb-10">
        <h2 class="text-3xl font-black text-color-blue">隱私權政策</h2>
        <h3 class="text-xl mt-3 sm:mt-0">v.20211202</h3>
      </div>
        <h3 class="text-2xl font-black my-5 text-left">適用範圍</h3>
        <p class="text-lg text-left">本處所述隱私權政策，適用於您在TAIE網站活動時，所涉及有關個人資料的蒐集、處理及利用。
        <br>使用者持續使用TAIE網站服務，即視為當事人明示同意下述之資料蒐集、處理，及利用方式。
        <br>TAIE得將您貢獻之內容推送至其他平台，如台灣生物多樣性網絡平台，於推送後就該平台之個人資料使用事宜，後續悉由該平台依其隱私權政策進行處理。</p>
        <h3 class="text-2xl font-black my-5 text-left">TAIE蒐集使用者資料</h3>
        <p class="text-lg text-left">使用者自主填註的各項個人識別資料，僅作為認證、授權標示，與相關通知、聯繫用。
        <br>本網站會蒐集您使用之瀏覽器、照片等所記錄之地理位置（含經緯度），本項資訊僅用於觀測記錄之顯示、分析與彙整。
        <br>若使用者未自設資訊屏蔽機制，TAIE部分功能會蒐集您的連線設備IP位址、登入時間，及使用瀏覽器等相關資訊。</p>
        <h3 class="text-2xl font-black my-5 text-left">TAIE對相關資料之去識別化與量化處理</h3>
        <p class="text-lg text-left">使用者同意TAIE得以對其回報資料進行合理妥適之去識別化或相關數據量化的處理。
        <br>處理後的資料與其個人識別狀態無法產生連結者，便不再屬於個人資料，後續將得以不受回報目的之限制，被進行利用。</p>
        <h3 class="text-2xl font-black my-5 text-left">隱私權保護政策修訂</h3>
        <p class="text-lg text-left">TAIE將不定時修訂本項政策，以符合最新的個人資料與相關法定權利之保護規範。
        <br>使用者對TAIE網站服務的繼續使用，視為明示同意更新版本的隱私權政策。</p>
        <h3 class="text-2xl font-black my-5 text-left">回報機制</h3>
        <p class="text-lg text-left">TAIE對於相關資料的收集，已踐履個人資料保護法及其相關法規的基礎要求，並在資料的處理及利用上，透過彙整或去識別化流程，
          以強化使用者的隱私防護。相關資料在處理之後，亦將進行科研公益目的之分享。
        <br>若您對於您的個人資料與貢獻之資料有隱私疑慮，請聯絡管理者，使用者若對您相關資料有進行查閱、更正、停止利用，以及刪除的意見，亦可透過網站回報機制進行提報。</p>
    </div>
  </div>
  <div class="footer-bg"></div>
</template>

<script>
export default {
  title: '使用條款及隱私權政策-TAIE'
};
</script>

<style scoped>
@media (min-width: 1536px) {
  .pagination-bg-2xl {
    width: 100%;
    height: 300px;
    background-image: url("../../assets/pagination-bg-over1536.jpg");
  }
}

@media (min-width: 1024px) and (max-width: 1535.98px) {
  .pagination-bg-lg {
    width: 100%;
    height: 300px;
    background-image: url("../../assets/pagination-bg-over1024.jpg");
  }
}

@media (min-width: 640px) and (max-width: 1023.98px) {
  .pagination-bg-sm {
    width: 100%;
    height: 300px;
    background-image: url("../../assets/pagination-bg-over640.jpg");
  }
}

@media (max-width: 639.98px) {
  .pagination-bg {
    width: 100%;
    height: 250px;
    background-image: url("../../assets/pagination-bg-under640.jpg");
  }
}

.text-color-blue {
  color: #466176;
}

.text-color-brown {
  color: #C9A798;
}

a:hover {
color:#64859D;
}

.source {
  color: #6D5B53;
}

.bg-color {
  background-color: #E5E9EC;
}

.footer-bg {
  width: 100%;
  height: 10px;
  background-image: url("../../assets/footer-bg-policies.svg");
}
</style>
